export default {
  hero_label: 'Member',
  hero_title: 'メンバー',
  hero_subtitle: 'AIで日本を変えるプロフェッショナル集団。',
  members: [
    {
      id: 1,
      name: "鈴木 章史",
      nameEn: "Akihito Suzuki",
      position: "代表取締役CEO",
      image: "/assets/member-suzuki.png",
      bio: "大手事業会社にて、AI・ブロックチェーン領域の事業戦略・事業企画に従事し、新規サービス責任者を担当。ITコンサルティング、システム品質保証、人材・営業支援など複数領域における事業立ち上げを、事業責任者および新規事業開発コンサルタントとしてリードし、全事業で成長率200%を実現し事業拡大に貢献。いち早くAIを業務に組み込み成果創出につなげてきた経験をもとに、AIX JAPANを創業。成果に徹底的にこだわり、各領域で実績を積み重ねてきた、AI×新規事業開発のプロフェッショナル。",
      career: [
        "2009年 - 大手戦略コンサルティングファーム入社",
        "2014年 - デジタル戦略部門マネージャー就任",
        "2018年 - AIソリューション事業本部長就任",
        "2021年 - AIX JAPAN創業"
      ]
    },
    {
      id: 2,
      name: "藤田 岳",
      nameEn: "Gaku Fujita",
      position: "AIコンサルタント",
      image: "/assets/member-fujita.png",
      bio: "大手セキュリティ系SIer、クリエイティブディレクターを経て、各種クライアントの業務自動化、AIコンサルタントに従事。クリエイティブからシステム開発、ツール導入、AI開発と幅広い業務に対応可能なジェネラリストとして活躍中。セキュリティ、製造業、インフラ系、デザイン系と多様な領域を跨いだAIコンサルティングを得意としている。創業初期にAIX JAPANに参画。",
      career: [
        "2011年 - 大手SIer入社",
        "2015年 - AIソリューション推進チームリーダー",
        "2019年 - AI戦略コンサルティング部門長",
        "2022年 - AIX JAPAN参画"
      ]
    },
    {
      id: 3,
      name: "行木 涼馬",
      nameEn: "Ryoma Nameki",
      position: "AIコンサルタント",
      image: "/assets/member-nameki.png",
      bio: "慶應義塾大学を卒業後、AI関連の研究、特許、技術分析に従事。世界各国のAI先端事例を調査しAIコンサルタントとして幅広いクライアントを支援。AIという幅広い領域で新たな構造を抽出し、クライアントの事業に組み込むことを得意とする。42Tokyo出身でプログラミング、システム構築も対応可能。東大松尾研究所AI講習修了。",
      career: [
        "2010年 - 人材開発コンサルティング企業入社",
        "2015年 - AI教育プログラム開発責任者",
        "2019年 - 企業向けAI研修事業立ち上げ",
        "2022年 - AIX JAPAN参画"
      ]
    }
  ]
};